import { PIViewTypes, VisualizationTypes } from '../../../../../types/data';

export const prepareData = (data: PIViewTypes.RadarChartEntity[]): VisualizationTypes.RadarChartTypes.DataList[] => {
    const formattedData: VisualizationTypes.RadarChartTypes.DataList[] = [];
    data.forEach(entity => {
        Object.keys(entity).forEach(attr => {
          // 对于每个属性，创建一个DataPoint数组
          const dataPoints: VisualizationTypes.RadarChartTypes.DataPoint[] = [];

          entity[attr].forEach(dataUnit => {
            Object.keys(dataUnit).forEach(key => {
              dataPoints.push({
                axis: key,
                value: dataUnit[key],
                attr: attr
              });
            });
          });

          // 添加到formattedData数组
          formattedData.push({
            attr,
            dataPointList: dataPoints
          });
        });
      });

    // console.log("==> formattedData", formattedData);

    return formattedData;
};